import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import { sharedStyles } from './shared/sharedStyles.js';
const GuestExpandedDetails = ({ guest, hasPremiumAccess }) => {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        marginTop: '-1px',
        padding: '1.5rem',
        background: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(10px)',
        border: '2px solid rgba(234, 88, 12, 0.2)',
        borderRadius: '0 0 12px 12px',
        boxShadow: '0 10px 40px rgba(234, 88, 12, 0.15)',
        zIndex: 200
      }}
    >
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1.5rem'
      }}>
        {/* Full Guest Info */}
        <div>
          <h4 style={{
            fontSize: '0.75rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '0.75rem'
          }}>
            Guest Information
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div>
              <div style={{ fontSize: '0.7rem', color: sharedStyles.colors.textTertiary, marginBottom: '0.125rem' }}>Name</div>
              <div style={{ fontSize: '0.875rem', fontWeight: '600', color: sharedStyles.colors.textPrimary }}>{guest.name}</div>
            </div>
            <div>
              <div style={{ fontSize: '0.7rem', color: sharedStyles.colors.textTertiary, marginBottom: '0.125rem' }}>Title</div>
              <div style={{ fontSize: '0.875rem', color: sharedStyles.colors.textSecondary }}>{guest.title}</div>
            </div>
            <div>
              <div style={{ fontSize: '0.7rem', color: sharedStyles.colors.textTertiary, marginBottom: '0.125rem' }}>Company</div>
              <div style={{ fontSize: '0.875rem', color: sharedStyles.colors.textSecondary }}>{guest.company}</div>
            </div>
            <div>
              <div style={{ fontSize: '0.7rem', color: sharedStyles.colors.textTertiary, marginBottom: '0.125rem' }}>Match Score</div>
              <div style={{ fontSize: '1.125rem', fontWeight: '700', color: sharedStyles.colors.primary }}>
                {(guest.relevanceScore * 10).toFixed(1)} / 10
              </div>
            </div>
          </div>
        </div>

        {/* Full Summary */}
        <div>
          <h4 style={{
            fontSize: '0.75rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '0.75rem'
          }}>
            Summary
          </h4>
          <p style={{
            fontSize: '0.875rem',
            color: sharedStyles.colors.textSecondary,
            lineHeight: '1.6',
            textAlign: 'left',
            margin: 0,
            paddingLeft: '0.5rem'
          }}>
            {guest.summary}
          </p>
        </div>

        {/* Expertise Areas */}
        {guest.expertiseAreas && guest.expertiseAreas.length > 0 && (
          <div>
            <h4 style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              color: sharedStyles.colors.textSecondary,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '0.75rem'
            }}>
              Expertise Areas
            </h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
              {guest.expertiseAreas.map((area, idx) => (
                <span key={idx} style={{
                  background: 'rgba(234, 88, 12, 0.1)',
                  color: sharedStyles.colors.accentBrown,
                  padding: '0.25rem 0.75rem',
                  borderRadius: '6px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {area}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Contact Information (Premium) */}
        {hasPremiumAccess && (
          <div>
            <h4 style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              color: sharedStyles.colors.textSecondary,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '0.75rem'
            }}>
              Contact Information
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {guest.socialMedia?.email && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Mail size={14} style={{ color: sharedStyles.colors.primary }} />
                  <a
                    href={`mailto:${guest.socialMedia.email}`}
                    style={{ fontSize: '0.875rem', color: sharedStyles.colors.primary, textDecoration: 'none' }}
                  >
                    {guest.socialMedia.email}
                  </a>
                </div>
              )}
              {guest.socialMedia?.linkedin && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Linkedin size={14} style={{ color: sharedStyles.colors.primary }} />
                  <a
                    href={guest.socialMedia.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: '0.875rem', color: sharedStyles.colors.primary, textDecoration: 'none' }}
                  >
                    {guest.socialMedia.linkedin.replace('https://', '')}
                  </a>
                </div>
              )}
              {guest.socialMedia?.twitter && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '14px', color: sharedStyles.colors.primary }}>𝕏</span>
                  <a
                    href={guest.socialMedia.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: '0.875rem', color: sharedStyles.colors.primary, textDecoration: 'none' }}
                  >
                    {guest.socialMedia.twitter.replace('https://', '').replace('http://', '')}
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GuestExpandedDetails;
